const { h, render, Component } = require('preact');
const {Portal} = require('preact-portal');

class RedemptionInstructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  openPopup(){
    this.setState({open: true});
  }

  closePopup(){
    this.setState({open: false});
  }

  getRedemptionInstructions(){
    if (lodash.has(this.props.orderDetails, 'dealOption.instructions') && this.props.orderDetails.dealOption.instructions){
      return (
        <div
          class="ssa-information"
          dangerouslySetInnerHTML={{ __html: this.props.orderDetails.dealOption.instructions }}
        />
      );
    }
    return null;
  }

  render() {
    let redemptionInstructions = this.getRedemptionInstructions()
    if (redemptionInstructions){
      return (
        <div class="ssa-links">
          <span class="ssa-link" data-bhw="web2018_redemption_instructions_link" onClick={this.openPopup}>
            {I18n.translate("js.modules.support.view_redemption_instructions")}
          </span>
          { this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_redemption_instructions_popup">
                <div>
                  <span class="icon-x" data-bhw="web2018_redemption_instructions_close_button" onClick={this.closePopup}></span>
                </div>
                <div class="ssa-link-title">
                {I18n.translate("js.modules.support.redemption_instructions")}
                </div>
                {redemptionInstructions}
              </div>
              <div class="shadow"></div>
            </Portal>
            )
          }
        </div>
      );
    }
    return null;
  }
}
module.exports = RedemptionInstructions
